module.exports = __webpack_public_path__ + "static/media/mill-nodata.e559a665.svg";